export default {
    title: 'Kategorie verknüpfen',
    attachCategoryText: 'Welche Kategorie möchten Sie mit den ausgewählten Organisationen verknüpfen?'
}